import { DataSourceType } from './constants';
import type { MetricDataSource } from './types';

export const isLDHosted = (dataSourceKey?: MetricDataSource['key']) =>
  typeof dataSourceKey === 'string' && dataSourceKey === DataSourceType.LAUNCHDARKLY_HOSTED;
